import { useEffect } from "react";
import { trackPageNavigation } from "~/lib/track-events";

export function useNavigationMonitor() {
  useEffect(() => {
    const handlePopState = (event: PopStateEvent) => {
      trackPageNavigation(
        "browser_history_change",
        window.location.pathname,
        window.location.search,
        window.location.hash,
        event.state
      );
    };

    // Add event listener for popstate (browser back/forward buttons)
    window.addEventListener("popstate", handlePopState);

    // Cleanup function
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);
}
